import { render, staticRenderFns } from "./BaseImageInput.vue?vue&type=template&id=68b20c32&scoped=true&"
import script from "./BaseImageInput.vue?vue&type=script&lang=js&"
export * from "./BaseImageInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseImageInput.vue?vue&type=style&index=0&id=68b20c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b20c32",
  null
  
)

export default component.exports